<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="transferTypes"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Allows the selection of a voucher type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-airportTransferType',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                transferTypes: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getTransferTypes();
        },
        methods: {
            getTransferTypes:function(){
                axios.get('/api/airport-transfer-types')
                .then(function(response){
                    console.log(response);
                    var transferTypes = [];
                    response.data.types.forEach(function(transferType){
                        transferTypes.push({ text: transferType.airport_transfer, value: transferType.airport_transfer_type_key });
                    });
                    this.transferTypes = transferTypes;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
